import React from 'react';
import {useLoading} from "../../components/context/LoadingContext";
import {useNavigate} from "react-router-dom";
import {Button} from "@mui/material";
import {MdEdit} from "react-icons/md";
import '../reports/ReportsPage.css'

const ReportItem = ({ report, onReportUpdated}) => {
    const [isLoading, setIsLoading] = useLoading();

    const navigate = useNavigate();

    const handleEdit = () => {
        navigate(`/reports/edit/${report.id}`, { state: { report } });
    };

    const getStatusLabel = (status) => {
        switch (status) {
            case 'inProgress':
                return 'В работе';
            case 'done':
                return 'Обработано';
            default:
                return 'Новое';
        }
    };

    return (
        <tr>
            <td className='text'>{report.text}</td>
            <td className='date'>{new Date(report.createdAt).toLocaleDateString()}</td>
            <td className='email'>{report.email}</td>
            <td className='platform'>{`${report.platform} ${report.systemVersion}`}</td>
            <td className='status'>{getStatusLabel(report.status)}</td>
            <td className='actions'>
                <div className='actions d-flex align-items-center'>
                    <Button className='success' color="success" onClick={handleEdit}><MdEdit/></Button>
                </div>
            </td>
        </tr>
    );
};

export default ReportItem;